import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { Card } from 'antd';

// const departmentData = [
//   { name: 'Advisory', value: 16000 },
//   { name: 'IT', value: 12000 },
//   { name: 'Billing', value: 9500 },
//   { name: 'Billing 2', value: 8700 },
//   { name: 'IT 2', value: 8000 },
//   { name: 'Advisory 3', value: 4000 },
//   { name: 'Advisory 4', value: 2000 },
// ];

const COLORS = [
  '#1890FF',
  '#FF4D4F',
  '#52C41A',
  '#FAAD14',
  '#722ED1',
  '#13C2C2',
  '#A0A0A0',
];

export default function OpenTicketsBarChart({ overViewData }) {
  return (
    <Card
      size='small'
      // title="Open Tickets by Department"
      className='open-tickets-card'
      style={{ margin: '0' }}
    >
      <div className='chart-header'>
        <div className='chart-title'>
          <span className='ticket-count'>Open Tickets by Department</span>
        </div>
      </div>
      <ResponsiveContainer width='100%' height={350}>
        <BarChart
          layout='vertical'
          data={overViewData}
          margin={{ top: 0, right: 20, bottom: 0, left: 20 }}
          barCategoryGap={12}
        >
          <CartesianGrid strokeDasharray='3 3' horizontal vertical={false} />
          <XAxis
            type='number'
            // tickFormatter={va}
            stroke='#999'
            fontSize={12}
            axisLine={false}
            tickLine={false}
            barSize={10}
          />
          <YAxis
            type='category'
            dataKey='departmentName'
            stroke='#000'
            fontSize={14}
            axisLine={false}
            tickLine={false}
          />
          <Bar dataKey='count' barSize={8} radius={[0, 6, 6, 0]}>
            {overViewData &&
              overViewData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
}
